import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import classes from './TextField.scss';

import { getContactTypes } from 'cityads-v3/actions/contactTypes';

import TextField from './TextField';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';

import IconFacebook from './ContactFieldIcons/facebook';
import IconLine from './ContactFieldIcons/line';
import IconPhone from './ContactFieldIcons/phone';
import IconQQ from './ContactFieldIcons/qq';
import IconSkype from './ContactFieldIcons/skype';
import IconSnapchat from './ContactFieldIcons/snapchat';
import IconTelegram from './ContactFieldIcons/telegram';
import IconViber from './ContactFieldIcons/viber';
import IconWechat from './ContactFieldIcons/wechat';
import IconWhatsApp from './ContactFieldIcons/whatsapp';

export const SKYPE = 'skype';
export const PHONE = 'phone';
export const TELEGRAM = '1';
export const QQ = '2';
export const FACEBOOK = '3';
export const WECHAT = '4';
export const VIBER = '5';
export const LINE = '6';
export const SNAPCHAT = '7';
export const WHATSAPP = '10';

const BANNED_CONTACT_TYPE_IDS = [
  FACEBOOK
]

const colors = {
  [SKYPE]:    '#00AFF0',
  [PHONE]:    '#bd245e',
  [TELEGRAM]: '#4b97d8',
  [QQ]:       '#030104',
  [FACEBOOK]: '#4267b2',
  [WECHAT]:   '#8BC34A',
  [VIBER]:    '#7F40BD',
  [LINE]:     '#00C200',
  [SNAPCHAT]: '#ebad1a',
  [WHATSAPP]: '#35897E',
}

export const Icons = props => {
  const { icon, ...others } = props;

  switch (props.icon) {
    default:
      return false;
    case SKYPE:
      return <IconSkype {...others}/>;
    case PHONE:
      return <IconPhone {...others}/>;
    case TELEGRAM:
      return <IconTelegram {...others}/>;
    case QQ:
      return <IconQQ {...others}/>;
    case FACEBOOK:
      return <IconFacebook {...others}/>;
    case WECHAT:
      return <IconWechat {...others}/>;
    case VIBER:
      return <IconViber {...others}/>;
    case LINE:
      return <IconLine {...others}/>;
    case SNAPCHAT:
      return <IconSnapchat {...others}/>;
    case WHATSAPP:
      return <IconWhatsApp {...others}/>;
  }
}

@connect(state => ({
  language: state.language.language,

  contactTypes: state.contactTypes.contactTypes
    .filter(item => state.language.language !== 'ru' || !BANNED_CONTACT_TYPE_IDS.includes(item))
    .map(item => state.contactTypes.contactTypesById[item]),
  isLoadedContactTypes: state.contactTypes.isLoaded,
}))
export default class ContactField extends Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,

    language: PropTypes.string,

    contactTypes: PropTypes.array,
    isLoadedContactTypes: PropTypes.bool,
  }

  componentDidMount() {
    const { dispatch, isLoadedContactTypes } = this.props;

    if (!isLoadedContactTypes) {
      dispatch(getContactTypes());
    }
  }

  componentDidUpdate(prevProps) {
    const { dispatch, language } = this.props;

    if (language !== prevProps.language) {
      dispatch(getContactTypes());
    }
  }

  render() {
    const {
      contactTypes,
      value,
      dispatch,
      isLoadedContactTypes,
      ...others
    } = this.props;


    return (
      <TextField
        select
        fullWidth={true}
        value={value}
        {...others}
      >
        {contactTypes.map(item => {
          const selected = value.indexOf(item.id) >= 0;

          return (
            <MenuItem
              key   = {item.id}
              value = {item.id}
              style = {{ color: selected ? colors[item.id] : null }}
            >
              <Checkbox
                checked     = {selected}
                icon        = {<Icons classes={{ root: classes.contactFieldIcon }} icon={item.id} />}
                checkedIcon = {<Icons classes={{ root: classes.contactFieldIcon }} icon={item.id} />}
                classes     = {{
                  root   : classes.contactFieldCheckbox,
                  checked: classes.contactFieldCheckboxChecked,
                }}
              />
              <ListItemText
                primary = {item.name}
                classes = {{
                  primary: classes.contactFieldLabel
                }}
              />
            </MenuItem>
          );
        })}
      </TextField>
    );
  }

}
